// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BiwZ","inner":"styles_inner__2uv-v","right":"styles_right__3d0ti","close":"styles_close__v631O","footer":"styles_footer__LNLeO"};